import { useTranslation } from 'react-i18next'
import { Handle, Position, type NodeProps } from '@xyflow/react'

import styles from './AddStateNode.module.scss'

const ADD_STATE_NODE_ID = '__add_state__'

export function AddStateNode({ data }: NodeProps) {
  const onAddState = data.onAddState as (() => void) | undefined
  const onAddGroup = data.onAddGroup as (() => void) | undefined
  const { t } = useTranslation()

  return (
    <div className={styles.wrapper} data-testid="add-state-node">
      <Handle type="target" position={Position.Top} id={`${ADD_STATE_NODE_ID}-target-0`} className={styles.handle} />
      <button type="button" className={styles.button} onClick={onAddState} data-testid="add-state-button">
        <span className={styles.plusIcon}>+</span>
        <span className={styles.label}>{t('stateMachine.toolbar.addState')}</span>
      </button>
      <button type="button" className={styles.button} onClick={onAddGroup} data-testid="add-group-button">
        <span className={styles.folderIcon} role="img" aria-label="folder">
          &#128193;
        </span>
        <span className={styles.label}>{t('stateMachine.toolbar.addGroup')}</span>
      </button>
    </div>
  )
}
